import React, { useContext, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "react-js-pagination";
import API from "../../API";
import { ShowContext, UserContext } from "../../App";

    const categoryList = [
        { id: 1, label: "Circular/Office Order" },
        { id: 2, label: "Training" },
        { id: 3, label: "GR" },
        { id: 4, label: "Important Links" },
        { id: 6, label: "Downloads" },
    ];

function NewsTable({
    circularData,
    setCircularData,
    edit,
    setEdit,
    editValues,
    setEditValues,
    getCirculardata,
}) {
    const { currentUser } = useContext(UserContext);
    const { setShow, setMsg } = useContext(ShowContext);
    const [header, setHeader] = useState();
    const [data, setData] = useState();

    const [curPage, setCurPage] = useState(0);
    const [perPage, setPerPage] = useState(0);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        if (circularData) {
            setCurPage(circularData.current_page);
            setPerPage(circularData.per_page);
            setTotal(circularData.total);
        }
    }, [circularData]);

    const getCategory = (catId) => {
        const category = categoryList.find((c) => c.id == catId);
        return category ? category.label : "";
    };

    const getHeader = () => {
        let myHeader = [
            { text: "Sr.\nNo.", dataField: "srno" },
            { text: "Date", dataField: "date" },
            {
                text: "Heading",
                dataField: "heading",
                // , formatter: (col, row) => { return <span style={{ display: 'block', width: "300px", overflowX: 'scroll', overflowY: 'hidden', whiteSpace: 'nowrap' }}>{col}</span> }
            },
            {
                text: "URL",
                dataField: "url",
                formatter: (col, row) => {
                    return (
                        <span
                            style={{
                                display: "block",
                                width: "300px",
                                overflowX: "scroll",
                                overflowY: "hidden",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {col}
                        </span>
                    );
                },
            },
            { text: "Category", dataField: "category" },
            { text: "Status", dataField: "status" },
            { text: "Edit", dataField: "edit" },
            { text: "Delete", dataField: "delete" },
        ];
        return myHeader;
    };

    useEffect(() => {
        if (circularData) {
            setHeader(getHeader());
            setData(
                getData(
                    circularData,
                    setShow,
                    setMsg,
                    setCircularData,
                    edit,
                    setEdit,
                    editValues,
                    setEditValues,
                    getCategory
                )
            );
        }
    }, [circularData, edit]);

    return (
        <>
            {currentUser && data ? (
                <>
                    <>
                        <BootstrapTable
                            keyField="srno"
                            data={data}
                            columns={header}
                            headerClasses="allTable_header text-center"
                        />
                    </>
                    <div className="mt-1">
                        <Pagination
                            totalItemsCount={total}
                            activePage={curPage}
                            itemsCountPerPage={perPage}
                            onChange={(pageNumber) => {
                                setCurPage(pageNumber);
                                getCirculardata(setCircularData, pageNumber);
                            }}
                            itemClass="page-item"
                            linkClass="page-link"
                            firstPageText="First"
                            lastPageText="Last"
                        />
                    </div>
                </>
            ) : null}
        </>
    );

    function getData(
        list,
        setShow,
        setMsg,
        setCircularData,
        edit,
        setEdit,
        editValues,
        setEditValues,
        getCategory
    ) {
        let myData = [];
        let i = (curPage - 1) * perPage + 1;
        if (list !== undefined && list?.data?.length > 0) {
            list?.data?.map((data, index) => {
                myData.push({
                    srno: i++,
                    date: data.date,
                    heading: data.heading,
                    url: data.url,
                    category: getCategory(data.category),
                    edit: (
                        <button
                            key={"btn_" + index}
                            className="btn btn-warning"
                            onClick={() => {
                                setEdit(true);
                                setEditValues(data);
                            }}
                            disabled={edit}
                        >
                            {edit && editValues?.id === data.id ? "Save" : "Edit"}
                        </button>
                    ),
                    status: (
                        <label className="switch" key={"label_" + index}>
                            <input
                                key={"input_" + index}
                                type="checkbox"
                                checked={Boolean(parseInt(data.status))}
                                onChange={() => {
                                    updateStatus(
                                        data.id,
                                        parseInt(data.status) ? 0 : 1,
                                        setShow,
                                        setMsg,
                                        list,
                                        setCircularData
                                    );
                                }}
                            />
                            <span key={"slider_" + index} className="slider round"></span>
                        </label>
                    ),
                    delete: (
                        <button
                            className="btn btn-danger"
                            onClick={() => {
                                deleteRecord(data.id, setShow, setMsg, list, setCircularData);
                            }}
                        >
                            Delete
                        </button>
                    ),
                });
            });
        }
        return myData;
    }

    async function deleteRecord(
        id,
        setShow,
        setMsg,
        circularData,
        setCircularData
    ) {
        await API.delete("/news", { params: { id: id } })
            .then((res) => {
                if (res.data.status === "success") {
                    setCircularData((pre) => ({
                        ...pre,
                        data: pre.data.filter((rec) => rec.id != id),
                    }));
                    // setCircularData(circularData.filter((rec) => rec.id != id));
                    setShow(true);
                    setMsg(res.data.message);
                }
            })
            .catch((error) => {
                setShow(true);
                setMsg(error.response.data.message);
            });
    }

    async function updateStatus(
        id,
        status,
        setShow,
        setMsg,
        circularData,
        setCircularData
    ) {
        await API.post("/news/disable", { id: id, status: status })
            .then((res) => {
                if (res.data.status === "success") {
                    // setLatestUpdates(latestUpdates.filter((rec) => rec.id != id));
                    setCircularData((pre) => ({
                        ...pre,
                        data: pre.data.map((rec) => {
                            if (rec.id != id) {
                                return rec;
                            } else {
                                return { ...rec, status: parseInt(rec.status) ? 0 : 1 };
                            }
                        }),
                    }));
                    setShow(true);
                    setMsg(res.data.message);
                }
            })
            .catch((error) => {
                setShow(true);
                setMsg(error.response.data.message);
            });
    }
}

export default NewsTable;
